import * as React from 'react';
import ParameterResult from "../Shared/ParameterResult";
import BestResult from "../Shared/BestResult";
import { Parameters, VolumetricParameter, FlowParameter, SvcResults, DiffusingCapacityParameter, StudySvcRelevantParameters, PressureParameter } from '../Shared/PFTAPITypes';
import ResultsGroupHeading from '../Shared/ResultsGroupHeading';

export interface SVCResultParametersProps {
    results: SvcResults;
    isLoading?: boolean;
    isRejected?: boolean;
    showConfiguredParametersOnly?: boolean;
    studySvcRelevantParameters?: StudySvcRelevantParameters;
}

export const SVCResultParameters = ({ results, isLoading, isRejected, showConfiguredParametersOnly, studySvcRelevantParameters }: SVCResultParametersProps) => {
    const renderBestValueResult = (parameter: VolumetricParameter | FlowParameter | DiffusingCapacityParameter | PressureParameter) => {
        const bestValue = results.BestParameters.find(br => br.ParameterType === parameter.ParameterType && br.Units === parameter.Units);

        if (bestValue) {
            return <BestResult isLoading={isLoading} result={bestValue}/>
        } else {
            return <td></td>;
        }
    }

    var parameters: Parameters; 
    if (showConfiguredParametersOnly) {
        parameters = studySvcRelevantParameters.AnalysisParameters ?? studySvcRelevantParameters.DefaultAnalysisParameters;
    } else {
        parameters = results.DisplayParameters;
    }

    return (
        <>
            <ResultsGroupHeading resultsCount={results.TestResults.length} title="Parameters" />
            
            {
                parameters.map(dp => {
                    
                    return (
                        <tr key={`DisplayedParameter${dp.ParameterType}_${dp.Units}`}>
                            <td>{dp.DisplayName}</td>
                            {
                                results.TestResults.sort((a, b) => a.TestNumber - b.TestNumber).map((tr, trIndex) => {
                                    return <ParameterResult 
                                                key={`Result_${dp.ParameterType}_${dp.Units}_${tr.TestId}`} 
                                                results={results.TestResults} 
                                                isRejected={isRejected}
                                                testIndex={trIndex}
                                                testNumber={tr.TestNumber}
                                                parameterId={dp.ParameterType} 
                                                units={dp.Units}
                                                automationSection='parameters'
                                        />
                                })
                            }
                            {renderBestValueResult(dp)}
                        </tr>
                    )
                })
            }
        </>
    );
}
